import { useCallback, useState } from 'react';

export function useRerender() {
  const [_, set] = useState(0);
  return useCallback(() => set((v) => v + 1), []);
}
